import { groupBy } from 'lodash';
import { useMemo } from 'react';

// Import hooks
import { useAppSelector } from 'store/hooks';

export const usePremiumPackets = () => {
	const { premium } = useAppSelector(({ configurator }) => configurator.packets);

	const groups = useMemo(() => {
		const packets = premium.filter((packet) => packet.context.external_provider);
		return Object.entries(groupBy(packets, 'context.external_provider'));
	}, []);

	const packets = useMemo(() => premium.filter((packet) => !packet.context.external_provider), []);

	return { groups, packets };
};
